export default function Loading() {
  return (
    <>
      <div id='ele-381' role="status" className="animate-pulse h-14 p-4">
        <div id='ele-382' className="animate-pulse h-14 items-center align-middle">
          <div id='ele-383' className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 max-w-[640px] mb-2.5 mx-auto"></div>
          <div id='ele-384' className="h-2.5 mx-auto bg-gray-300 rounded-full dark:bg-gray-700 max-w-[540px]"></div>
          <span id='ele-385' className="sr-only">Loading...</span>
        </div>
      </div>

    </>
  )
}